import { Observable } from 'rxjs';

import { LoadingService } from '../services/loading.service';
import { AppInjector } from '../../app.injector';

export function LoadingWrapper<T>(loadingTag: string): MethodDecorator {
    return function (target: unknown, propertyKey: string, descriptor: PropertyDescriptor): void {
        const originalMethod: Function = descriptor.value;

        descriptor.value = function (...args: unknown[]): Observable<unknown> {
            const loadingServiceInstance: LoadingService =
                AppInjector.get().get(LoadingService);
            return loadingServiceInstance.loadingWrapper<T>(
                originalMethod.apply(this, args),
                loadingTag,
            );
        };
    };
}
